export default __webpack_public_path__ + "static/media/phonepe-processing.2fc50bd6.jpg";